import React from 'react'

export interface IconWithBackgroundProps {
  icon: React.ReactNode
  size?: 'sm' | 'md' | 'lg'
  backgroundClassName?: string // override bg; default sun-20
  iconClassName?: string // override icon color; default text-sun
  className?: string
}

const sizeMap = {
  sm: 'w-8 h-8',
  md: 'w-12 h-12',
  lg: 'w-16 h-16'
} as const

const IconWithBackground: React.FC<IconWithBackgroundProps> = ({
  icon,
  size = 'md',
  backgroundClassName = 'bg-sun-20',
  iconClassName = 'text-sun',
  className = ''
}) => {
  return (
    <div
      className={`flex-shrink-0 rounded-lg ${sizeMap[size]} ${backgroundClassName} flex items-center justify-center ${className}`}
    >
      <span className={`${iconClassName}`}>{icon}</span>
    </div>
  )
}

export default IconWithBackground
